export default __webpack_public_path__ + "static/media/logo.73f15206.png";